import app from '@/app';
import Notifications from '@kyvg/vue3-notification'

app.use(Notifications)
